export default __webpack_public_path__ + "static/HelveticaLT67MediumCondensed-b24441891f6bbe86df8cbd905174a9ea.woff";